import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FloatLabelType } from '@angular/material/form-field';
import { Router } from '@angular/router';
import { UserType } from 'src/app/user-roles';

@Component({
  selector: 'sc-company-search',
  templateUrl: './company-search.component.html',
  styleUrls: ['./company-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CompanySearchComponent implements OnInit {
  @ViewChild('autoComplete', { read: MatAutocompleteTrigger })
  auto: MatAutocompleteTrigger;
  @Output() search: EventEmitter<any> = new EventEmitter();
  @Output() itemSelected: EventEmitter<any> = new EventEmitter();
  @Output() clear: EventEmitter<any> = new EventEmitter();

  @Input() redirectOnSearch = false;
  @Input() inputRequired: boolean = false;
  @Input('customPlaceHolder') customPlaceHolder: string = '';
  @Input() preSelected = null;
  @Input() floatingLabel: FloatLabelType = 'auto';

  userType = UserType;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onSearch(search) {
    if (!this.redirectOnSearch) {
      return;
    }

    this.router.navigate(['companies'], { state: { searchQuery: search } });
  }

  displayFn(company: SearchedCompany) {
    const { CompanyNumber, CompanyName, ContactEmail } = company;

    let display: string = '';

    if (company && typeof company == 'object') {
      display = `${CompanyName && CompanyName} ${CompanyNumber && CompanyNumber} ${ContactEmail && ContactEmail}`;
    } else {
      display = String(company);
    }

    return display.trim();
  }

  selectCompany(company: any) {
    this.itemSelected.emit(company);
  }
}

interface SearchedCompany {
  CompanyName: string;
  CompanyNumber: string;
  ContactEmail: string;
  CountryName: string;
  InvoiceEmails: string;
  InvoiceName: string;
  PhoneNumber: string;
  PK_CompanyID: number;
}
